<div class="card-container">
  <mat-card class="left-card">
    <mat-card-content class="card-content">
      <h1 class="playground-title">Playground</h1>
      <p class="playground-subtitle">Interact directly with the LLM</p>
      <div class="mt-4">
        <mat-card class="preview-card">
          <div class="card-content-wrapper">
            <mat-card-content class="preview-content">
              <ng-container *ngIf="modelResponse; else promptLoadingAnimation">
                @if (promptFinished) {
                  <markdown
                    mermaid
                    [data]="modelResponse"
                    [mermaidOptions]="mermaidChartingConfig"
                    #markdownDisplay></markdown>
                } @else {
                  <div>{{ modelResponse }}</div>
                }
              </ng-container>
              <ng-template #promptLoadingAnimation>
                <p *ngIf="promptLoading" class="loading-text">
                  <span class="ellipsis"></span>
                </p>
                <p *ngIf="!promptLoading" class="placeholder-text">Prompt response will appear here...</p>
              </ng-template>
            </mat-card-content>
            <br /><br /><br />
            <div class="icon-buttons">
              <button
                mat-icon-button
                [matMenuTriggerFor]="modelMenu"
                color="accent"
                matTooltip="Change Model"
                *ngIf="modelResponse && promptFinished">
                <mat-icon>auto_awesome</mat-icon>
              </button>
              <button
                mat-icon-button
                color="warn"
                matTooltip="Reset"
                *ngIf="modelResponse && promptFinished"
                (click)="clearPromptResult()">
                <mat-icon>refresh</mat-icon>
              </button>
              <button
                mat-icon-button
                color="accent"
                matTooltip="Copy to clipboard"
                *ngIf="modelResponse && promptFinished"
                (click)="copyToClipboard()">
                <mat-icon>content_copy</mat-icon>
              </button>

              <mat-menu #modelMenu="matMenu" xPosition="before" overlapTrigger="true" class="custom-menu">
                <button
                  mat-menu-item
                  *ngFor="let model of models.modelList"
                  [disabled]="model === selectedModel"
                  (click)="selectModel(model)"
                  class="model-options">
                  {{ model.name }}
                </button>
              </mat-menu>
            </div>
          </div>
        </mat-card>
      </div>

      <mat-form-field class="full-width textarea-container" color="accent">
        <textarea
          matInput
          cdkTextareaAutosize
          #autosize="cdkTextareaAutosize"
          [(ngModel)]="prompt"
          rows="1"
          placeholder="Enter your prompt..."
          [disabled]="promptInProgress"
          (keydown.enter)="runPrompt()"
          cdkAutosizeMinRows="1"
          [cdkAutosizeMaxRows]="promptInProgress || promptFinished ? 1 : 4"></textarea>
        <button
          mat-icon-button
          matSuffix
          (click)="runPrompt()"
          [disabled]="!prompt || promptInProgress"
          class="send-button">
          <mat-icon>send</mat-icon>
        </button>
      </mat-form-field>
    </mat-card-content>
  </mat-card>

  <mat-card class="right-card">
    <mat-card-title>Prompt History</mat-card-title>
    <div *ngIf="logsLoading" class="loading-container">
      <mat-spinner></mat-spinner>
    </div>
    <mat-list class="options-list" role="list" *ngIf="promptTemplates.length">
      <mat-list-item role="listitem" *ngFor="let option of promptTemplates" (click)="setTemplate(option.prompt)">
        <small>{{ option.title }}</small>
      </mat-list-item>
    </mat-list>
  </mat-card>
</div>
